var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHash = function SvgIconHash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.679 2.766a1 1 0 0 1 .805 1.163L10.744 8h3.967l.805-4.429a1 1 0 0 1 1.968.358L16.744 8H21a1 1 0 1 1 0 2h-4.62l-.727 4h4.26a1 1 0 1 1 0 2h-4.624l-.805 4.429a1 1 0 0 1-1.968-.358l.74-4.07H9.29l-.805 4.428a1 1 0 0 1-1.968-.358l.74-4.07H3a1 1 0 0 1 0-2h4.62l.727-4h-4.26a1 1 0 0 1 0-2h4.624l.805-4.43a1 1 0 0 1 1.163-.805M10.38 10l-.727 4h3.967l.727-4z",
    clipRule: "evenodd"
  })));
};
export default SvgIconHash;